const excelLeaveBalanceReducer = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default excelLeaveBalanceReducer;
